var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8164 10.3086L15.1914 4.68359C14.9473 4.43945 14.5516 4.43945 14.3078 4.68359C14.0641 4.92773 14.0637 5.32344 14.3078 5.56719L18.8672 10.125H7.875C7.53125 10.125 7.25 10.4062 7.25 10.75C7.25 11.0938 7.52953 11.375 7.875 11.375H18.8672L14.3086 15.9336C14.0645 16.1777 14.0645 16.5734 14.3086 16.8172C14.5527 17.0609 14.9484 17.0613 15.1922 16.8172L20.8172 11.1922C20.9375 11.0703 21 10.9102 21 10.75C21 10.5898 20.9375 10.4297 20.8164 10.3086ZM7.875 18.25H4.125C3.09102 18.25 2.25 17.4102 2.25 16.375V5.125C2.25 4.09102 3.09102 3.25 4.125 3.25H7.875C8.21875 3.25 8.5 2.97031 8.5 2.625C8.5 2.27969 8.21875 2 7.875 2H4.125C2.40156 2 1 3.40156 1 5.125V16.375C1 18.0977 2.40156 19.5 4.125 19.5H7.875C8.21875 19.5 8.5 19.2188 8.5 18.875C8.5 18.5312 8.21875 18.25 7.875 18.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.133fac4fc5f5c3a182ccbc5b5d4e7a4d.svg";
export { ForwardRef as ReactComponent };